import { type FunctionComponent } from "react";

import { ClientSideSuspense } from "shared/components/common/client-side-suspense";

import type { HeaderFeatureCommonProps } from "scmp-app/components/header/features/types";

import { PostMagazineOnelineMenuContent } from "./post-magazine-oneline-menu-content";

export type PostMagazineOnelineMenuProps = HeaderFeatureCommonProps;

export const PostMagazineOnelineMenu: FunctionComponent<PostMagazineOnelineMenuProps> = props => (
  <ClientSideSuspense>
    <PostMagazineOnelineMenuContent {...props} />
  </ClientSideSuspense>
);

PostMagazineOnelineMenu.displayName = "PostMagazineOnelineMenu";
